import { defineNuxtPlugin } from '#app'
import { getCityFromDomain } from '../utils/getCityFromDomain'
import type { Mode } from '../types'

/*
 Плагин для определения хоста приложения, с дальнейшим прокидыванием в nuxt
 Нужен для удобного доступа к хосту приложения в pageMeta и middleware
*/
export default defineNuxtPlugin(({ ssrContext }) => {
  const { MODE } = useRuntimeConfig().public
  let host = ''
  let cityPrefix = ''

  if (process.server) {
    const ssrHost = ssrContext?.event?.node?.req?.headers?.host || ''

    if (!ssrHost) {
      createError({
        statusCode: 500,
      })
    }

    host = ssrHost
    cityPrefix = getCityFromDomain(ssrHost, MODE as Mode)
  } else {
    host = window.location.host
    cityPrefix = getCityFromDomain(window.location.host, MODE as Mode)
  }

  return {
    provide: {
      host,
      cityPrefix,
    },
  }
})
